import { useState, useEffect } from "react";
import api from "../../services/api";
import { toast } from "react-toastify";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from "@mui/material";

export default function SelectQueue({ handleChange }) {
  const [value, setValue] = useState([]);
  const [queueList, setQueueList] = useState([]);

  const fillData = async () => {
    try {
      const res = await api.get("/api/espresso/hibernation/findAll", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (res.data.data.length === 0) {
        toast.warn("Usuário não possui filas cadastradas");
      } else {
        setQueueList(res.data.data.map((item) => item.queueName));
      }
    } catch (error) {
      toast.error("Filas não encontradas");
    }
  };

  useEffect(() => {
    fillData();
  }, []);

  const handleChangeInternal = (event) => {
    const {
      target: { value },
    } = event;
    const selected = typeof value === "string" ? value.split(",") : value;
    setValue(selected);
    handleChange(selected);
  };

  return (
    <FormControl fullWidth>
      <InputLabel
        id="multi-select-label"
        sx={{
          fontSize: "14px", // << diminui o tamanho da fonte do label
          // opcional, ajusta a posição do label para ficar mais alinhado
        }}
      >
        Selecione as filas
      </InputLabel>
      <Select
        labelId="multi-select-label"
        multiple
        value={value}
        onChange={handleChangeInternal}
        input={<OutlinedInput label="Selecione as filas" />}
        renderValue={(selected) =>
          selected.length === 0
            ? "Selecione as filas"
            : `${selected.length} selecionadas`
        }
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 240,
            },
          },
        }}
        sx={{
          height: 40,
          width: "180px",
          fontSize: "14px",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          borderRadius: "4px",
          backgroundColor: "#FFF",
          color: "#000",

          "& .MuiSelect-select": {
            color: "#000 !important", // <- força a cor do texto selecionado
            display: "flex",
            alignItems: "center",
            paddingTop: 0,
            paddingBottom: 0,
            fontSize: "10px",
          },

          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#ced4da",
          },

          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#aaa",
          },

          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#86b7fe",
          },
        }}
      >
        {queueList.map((name) => (
          <MenuItem key={name} value={name}>
            <Checkbox checked={value.includes(name)} />
            <ListItemText primary={name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
